import { useParams } from "react-router";

import { useEffect, useState } from "react";

import {
    getFirestore,
    doc,
    updateDoc,
    getDoc
} from "firebase/firestore"; 

import "./Admin.css";

import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import Modal from "../../components/Modal";
import useModal from "../../hooks/useModal";
import { Switch } from "../../components/Input";
import { InputText } from "../../components/Input";
import {QRCodeCanvas} from 'qrcode.react';

import app from "../../utils/Firebase";
const storage = getStorage();


const db = getFirestore(app);

export default function Admin(){
    const { local_id } = useParams();
    // const local_id = "prueba-horarios";
    const { modalState, setModalState, handleModalClose } = useModal();
    const [ localData, setLocalData ] = useState(null);
    const [ openingDays, setOpeningDays ] = useState({
        "lunes": false,
        "martes": false,
        "miercoles": false,
        "jueves": false,
        "viernes": false,
        "sabado": false,
        "domingo": false,
    });

    const [ tableNumber, setTableNumber ] = useState();
    console.log("Estamos en el admin");

    useEffect( () => {
        getCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const deleteItem = async (category, itemToDelete) => {
        console.log(category, itemToDelete);
        if(itemToDelete.url_img.length > 0){
            console.log(itemToDelete.url_img);
            let image_url = decodeURI(itemToDelete.url_img);
    
            try {   
                image_url = image_url.split(local_id+"%2F")[1];
                image_url = image_url.split("?alt=")[0];
            }
    
            catch (error) {
                alert("Error obteniendo la imagen del producto");
                return;
            }
    
            const storage = getStorage();
    
            // Create a reference to the file to delete
            const desertRef = ref(storage, 'imagenes-productos/'+local_id+"/"+image_url);
    
    
                    // Delete the file
            let iteme_deleted = await deleteObject(desertRef);
    
            console.log(iteme_deleted);
            let newCategoryArray = localData.menu[category].filter( item => item !== itemToDelete );
    
            const localRef = doc(db, "locales", local_id);
            await updateDoc(localRef,{ ["menu."+category] : newCategoryArray });
            getCategories();
        }
        else{
            let newCategoryArray = localData.menu[category].filter( item => item !== itemToDelete );
    
            const localRef = doc(db, "locales", local_id);
            await updateDoc(localRef,{ ["menu."+category] : newCategoryArray });
            getCategories();
        }
        
    }

    const getCategories = async () => {
        const localCol = doc(db, 'locales', local_id);
        const localsnapshot = await getDoc(localCol);
        let local = localsnapshot.data();
        console.log(local);
        setLocalData(local);
        setOpeningDays({
            "lunes": local.horario.lunes.abierto,
            "martes": local.horario.martes.abierto,
            "miercoles": local.horario.miercoles.abierto,
            "jueves": local.horario.jueves.abierto,
            "viernes": local.horario.viernes.abierto,
            "sabado": local.horario.sabado.abierto,
            "domingo": local.horario.domingo.abierto,
        })
        // const localesList = (localesSnapshot.docs.map(doc => doc.data()));
        // console.log(localesList);
    }

    const createNewCategory = async evt => {
        evt.preventDefault();
        let nueva_categoria = evt.target.nombre_categoria.value;
        console.log(nueva_categoria, local_id);

        const localRef = doc(db, "locales", local_id);

        try {
            await updateDoc(localRef,{ ["menu."+nueva_categoria] : [] });
            evt.target.reset();
            handleModalClose();
            getCategories();

        } catch (error) {
            alert('Error al crear la categoria');
        }
    }

    const createNewItem = async (evt, category) =>{
        evt.preventDefault();
        let nombre_producto = evt.target.nombre_producto.value;
        let precio = evt.target.precio.value;
        // let url_img = evt.target.url_img.value;
        let descripcion = evt.target.descripcion.value;

        let newItem = {
            nombre: nombre_producto,
            precio,
            url_img: '',
            descripcion,
        };

        let file = evt.target.product_img.files[0];


        const updateItem = async (item) => {
            const localRef = doc(db, "locales", local_id);
            let newItemArray = [ ];
    
            console.log(category);
            
            if(localData.menu[category]){
                newItemArray = [...(localData.menu[category]), item]
            }
    
            else{
                newItemArray = [item];
            }
    
            console.log(newItemArray);
    
    
            try {
                await updateDoc(localRef,{ ["menu."+category] : newItemArray });
                evt.target.reset();
                handleModalClose();
                getCategories();
    
            } catch (error) {
                console.log(error);
            }
        }
        if(file){
            let filename = 'imagenes-productos/'+ local_id+"/"+file.name;
            const storageRef = ref(storage, filename );
            console.log(file);
            // const fileReference = storageRef(storage, file.name)
    
            uploadBytes(storageRef, file).then( (snapshot) => {
                console.log('Uploaded a blob or file!');
                console.log(snapshot);
                getDownloadURL(ref(storage, filename))
                    .then( async (url) => {
                        console.log(url);
                        newItem.url_img = url;
                        await updateItem(newItem);
                    });
            });
        }

        else{
            await updateItem(newItem);
        }



    }

    const changeOpeningDay = (day, evt) => {
        // console.log(day, evt.target.checked);
        let new_opening_days = {...openingDays};
        new_opening_days[day] = evt.target.checked;
        setOpeningDays(new_opening_days);
    }


    const newCategoryModal = <div>
        <form onSubmit={ createNewCategory }>
            <InputText name='nombre_categoria' placeholder='Nombre categoria' />
            <button className='button button__primary' type='submit' style={ { marginTop: '20px' } }>Guardar</button>
        </form>
    </div>;

    const newItemModal = category => <div>
        <form onSubmit={ (event) => createNewItem(event, category) }>
            <InputText name='nombre_producto' placeholder='Nombre' />
            <InputText name='precio' placeholder='Precio' />
            {/* <InputText name='url_img' placeholder='URL imagen' /> */}
            <div className="product-img-container" style={ {margin: '20px auto'} }>
                <label>
                    Imagen del producto<br></br>
                    <input type="file" name="product_img" id="product_img"/>
                </label>
            </div>
            <InputText name='descripcion' placeholder='Descripción' />

            <button className='button button__primary' type='submit' style={ { marginTop: '20px' } }>Guardar</button>
        </form>
    </div>;


    const showNewCategoryModal = () => {
        setModalState(
            {
                visible: true,
                content: newCategoryModal,
                title: 'Nueva categoria'         
            }
        )
    }

    const showNewItemModal = category => {
        setModalState(
            {
                visible: true,
                content: newItemModal(category),
                title: 'Nuevo elemento'         
            }
        )
    }

    let categories = [];
    if(localData){
        for(let category in localData.menu){
            categories.push(category);
        }
    }

    const logOut = () => {
        localStorage.removeItem("JWT");
        window.location.assign("/login");
    };

    const editarLocal = async evt => {
        evt.preventDefault();

        let horario = {
            lunes: {
                abierto: openingDays.lunes,
                apertura: evt.target['lunes-apertura'].value,
                cierre: evt.target['lunes-cierre'].value,
            },
            martes: {
                abierto: openingDays.martes,
                apertura: evt.target['martes-apertura'].value,
                cierre: evt.target['martes-cierre'].value,
            },

            miercoles: {
                abierto: openingDays.miercoles,
                apertura: evt.target['miercoles-apertura'].value,
                cierre: evt.target['miercoles-cierre'].value,
            },

            jueves: {
                abierto: openingDays.jueves,
                apertura: evt.target['jueves-apertura'].value,
                cierre: evt.target['jueves-cierre'].value,
            },

            viernes: {
                abierto: openingDays.viernes,
                apertura: evt.target['viernes-apertura'].value,
                cierre: evt.target['viernes-cierre'].value,
            },

            sabado: {
                abierto: openingDays.sabado,
                apertura: evt.target['sabado-apertura'].value,
                cierre: evt.target['sabado-cierre'].value,
            },

            domingo: {
                abierto: openingDays.domingo,
                apertura: evt.target['domingo-apertura'].value,
                cierre: evt.target['domingo-cierre'].value,
            },
        }

        console.log(horario);

        let local_data = {
            nombre: evt.target.nombre_local.value,
            horario,
            // logo: '',
            acepta_reservaciones: localData.acepta_reservaciones,
            realiza_envios: localData.realiza_envios,
            datos_contacto: {
                telefono: evt.target.telefono.value,
                correo: evt.target.correo.value,
                direccion: {
                    calle: evt.target.calle.value,
                    localidad: evt.target.localidad.value,
                    municipio: evt.target.municipio.value,
                    estado: evt.target.estado.value
                },
                facebook: evt.target.facebook.value,
                instagram: evt.target.instagram.value,
            },
        };
        console.log(local_data);


        if(local_data.nombre.length > 0){

            // Guardamos la imagen del local antes de guardar los datos
            let file = evt.target.logo_file.files[0];
            if(file != null){

                // Vamos a eliminar el logo anterior
                let image_url = decodeURI(localData.logo);
                console.log(image_url);

                try {
                    image_url = image_url.split("logos-negocios%2F")[1];
                    image_url = image_url.split("?alt=")[0];
                }
        
                catch (error) {
                    alert("Error obteniendo la imagen del producto");
                    return;
                }
        
                const storage = getStorage();
        
                // Create a reference to the file to delete
                const desertRef = ref(storage, 'logos-negocios/'+image_url);
        
                // Delete the file
                let item_deleted = await deleteObject(desertRef);
                console.log("Se elimino el archivo?" + item_deleted);
                
                // Create a storage reference from our storage service
                let filename = 'logos-negocios/'+file.name;
                const storageRef = ref(storage, filename );
                console.log(file);
                // const fileReference = storageRef(storage, file.name)

                uploadBytes(storageRef, file).then( (snapshot) => {
                    console.log('Uploaded a blob or file!');
                    console.log(snapshot);
                    getDownloadURL(ref(storage, filename))
                        .then( async (url) => {
                            console.log(url);
                            local_data.logo = url;

                            try {
                                await updateDoc(doc(db, 'locales', local_id), local_data);
                                getCategories();
                                evt.target.reset();
                                // console.log("Document written with ID: ", docRef);
                            }
                
                            catch (e) {
                                console.error("Error adding document: ", e);
                                alert('Error saving the doc :(');
                            }
                        });
                });
            }

            else{
                console.log("No hay imagen del local");
                try {
                    await updateDoc(doc(db, 'locales', local_id), local_data);
                    getCategories();
                    evt.target.reset();
                    // console.log("Document written with ID: ", docRef);
                }
    
                catch (e) {
                    console.error("Error adding document: ", e);
                    alert('Error saving the doc :(');
                }
            }
        }

        console.log(local_data);
    }

    const getQRCodeURL = () => {
        if(tableNumber)
            return `https://encargamelo.netlify.app/${local_id}/mesa/${tableNumber}`;
        return `https://encargamelo.netlify.app/${local_id}/`;
    }

    const changeAcceptReservation = (val) => {
        console.log(val.target.checked);
        setLocalData({...localData, acepta_reservaciones: val.target.checked})
    }
    
    const changeShippingAvailable = (val) => {
        setLocalData({...localData, realiza_envios: val.target.checked})

    }

    return(
        <div className='admin-page'>
            {/* <a href="/">Regresar</a> */}
            <button onClick={ logOut }>Cerrar sesión</button>

            <div className='category-list'>
            <h2>Menú <strong>{ local_id }</strong></h2>

                {
                    categories.map( cat => <div className='category-container'>
                        <h3 className='category'>{ cat }</h3>
                        <button onClick={ () => { showNewItemModal(cat); } } className='button'><FontAwesomeIcon icon={ faPlus } /> Agregar</button>

                        <div className='items'>
                        {
                        localData.menu[cat] ?
                        localData.menu[cat].map( item => <div className='item'>
                                <div className='item-data'>
                                    <h3>{ item.nombre }</h3>
                                    <h5>$ { item.precio }</h5>
                                </div>

                                <div className='item-image' style={
                                    {
                                        backgroundImage: `url(${item.url_img})`,
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        width: '60px',
                                        height: '40px'
                                    }
                                }></div>

                                <button onClick={ () => { deleteItem(cat, item); }}>
                                    <FontAwesomeIcon icon={ faTrash } size='2x' />
                                </button>
                            </div>)
                         : null}

                        </div>
                    </div>)
                }
            </div>

            <button className='button button__secondary' style={ {marginTop: '20px'} } onClick={ showNewCategoryModal }><FontAwesomeIcon icon={ faPlus } /> Nueva categoria</button>


            <form onSubmit={ editarLocal }>
                <InputText name='nombre_local' placeholder='Nombre negocio' value={ localData ? localData.nombre : ""}/>

                <br/>
                <h3>Horario</h3>
                <br/>
                <table>
                    <thead>
                        <tr>
                            <th>Día</th>
                            <th>Abierto</th>
                            <th>Apertura</th>
                            <th>Cierre</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>Lunes</td>
                            <td><Switch onChange={ (val) => changeOpeningDay('lunes', val)} checked={ openingDays.lunes } /> </td>
                            <td><input type={"time"} name="lunes-apertura" defaultValue={ localData ? localData.horario.lunes.apertura : "" }/></td>
                            <td><input type={"time"} name="lunes-cierre" defaultValue={ localData ? localData.horario.lunes.cierre : '' }/></td>
                        </tr>

                        <tr>
                            <td>Martes</td>
                            <td><Switch onChange={ (val) => changeOpeningDay('martes', val)} checked={ openingDays.martes } /> </td>
                            <td><input type={"time"} name="martes-apertura" defaultValue={ localData ? localData.horario.martes.apertura : '' }/></td>
                            <td><input type={"time"} name="martes-cierre" defaultValue={ localData ? localData.horario.martes.cierre : '' }/></td>
                        </tr>

                        <tr>
                            <td>Miercoles</td>
                            <td><Switch onChange={ (val) => changeOpeningDay('miercoles', val)} checked={ openingDays.miercoles }/> </td>
                            <td><input type={"time"} name="miercoles-apertura" defaultValue={ localData ? localData.horario.miercoles.apertura : '' }/></td>
                            <td><input type={"time"} name="miercoles-cierre" defaultValue={ localData ? localData.horario.miercoles.cierre : '' }/></td>
                        </tr>

                        <tr>
                            <td>Jueves</td>
                            <td><Switch onChange={ (val) => changeOpeningDay('jueves', val)} checked={ openingDays.jueves } /> </td>
                            <td><input type={"time"} name="jueves-apertura" defaultValue={ localData ? localData.horario.jueves.apertura : '' }/></td>
                            <td><input type={"time"} name="jueves-cierre" defaultValue={ localData ? localData.horario.jueves.cierre : '' }/></td>
                        </tr>

                        <tr>
                            <td>Viernes</td>
                            <td><Switch onChange={ (val) => changeOpeningDay('viernes', val)} checked={ openingDays.viernes } /> </td>
                            <td><input type={"time"} name="viernes-apertura" defaultValue={ localData ? localData.horario.viernes.apertura : '' }/></td>
                            <td><input type={"time"} name="viernes-cierre" defaultValue={ localData ? localData.horario.viernes.cierre : '' }/></td>
                        </tr>

                        <tr>
                            <td>Sabado</td>
                            <td><Switch onChange={ (val) => changeOpeningDay('sabado', val)} checked={ openingDays.sabado } /> </td>
                            <td><input type={"time"} name="sabado-apertura" defaultValue={ localData ? localData.horario.sabado.apertura : '' }/></td>
                            <td><input type={"time"} name="sabado-cierre" defaultValue={ localData ? localData.horario.sabado.cierre : '' }/></td>
                        </tr>

                        <tr>
                            <td>Domingo</td>
                            <td><Switch onChange={ (val) => changeOpeningDay('domingo', val)} checked={ openingDays.domingo }/> </td>
                            <td><input type={"time"} name="domingo-apertura" defaultValue={ localData ? localData.horario.domingo.apertura : '' }/></td>
                            <td><input type={"time"} name="domingo-cierre" defaultValue={ localData ? localData.horario.domingo.cierre : '' }/></td>
                        </tr>
                    </tbody>
                </table>
                
                <InputText name='telefono' placeholder='Teléfono' value={localData ? localData.datos_contacto.telefono : ''}/>
                <InputText name='correo' placeholder='Correo' value={localData ? localData.datos_contacto.correo : ''}/>
                {/* <InputText name='logo' placeholder='URL del logo' /> */}
                <div className="logo-container">
                    <label>
                        Logo<br></br>
                        <input type="file" plcaeholder="Logo" name="logo_file" id="logo_file"/>
                    </label>
                </div>
                <br></br>
                <h3>Dirección</h3>
                <InputText name='calle' placeholder='Calle' value={localData ? localData.datos_contacto.direccion.calle : ''}/>
                <InputText name='localidad' placeholder='Localidad' value={localData ? localData.datos_contacto.direccion.localidad : ''}/>
                <InputText name='municipio' placeholder='Municipio' value={localData ? localData.datos_contacto.direccion.municipio : ''}/>
                <InputText name='estado' placeholder='Estado' value={localData ? localData.datos_contacto.direccion.estado : ''}/>
                <div className='radio-controls'>
                    <h5>Acepta reservaciones</h5>
                    <Switch onChange={ (val) => changeAcceptReservation(val)} checked={localData ? localData.acepta_reservaciones : null}/>

                    {/* <label>
                        Si
                        <input type='radio' name='acepta_reservaciones' value='1' checked={ localData ? localData.acepta_reservaciones: false }/>
                    </label>

                    <label>
                        No
                        <input type='radio' name='acepta_reservaciones' value='0' checked={ localData ? (localData.acepta_reservaciones === false ? true : false) : false }/>
                    </label> */}
                </div>

                <div className='radio-controls'>
                    <h5>Realiza envios</h5>
                    <Switch onChange={ (val) => changeShippingAvailable(val)} checked={localData ? localData.realiza_envios : null}/>

                    {/* <label>
                        Si
                        <input type='radio' name='realiza_envios' value='1' checked={ localData ? localData.realiza_envios : false }/>
                    </label>

                    <label>
                        No
                        <input type='radio' name='realiza_envios' value='0' checked={ localData ? (localData.realiza_envios === false ? true : false) : false }/>
                    </label> */}
                </div>

                <InputText name='facebook' placeholder='Facebook' value={localData ? localData.datos_contacto.facebook : ''} />
                <InputText name='instagram' placeholder='Instagram' value={localData ? localData.datos_contacto.instagram : ''} />

                <button className='button button__secondary' style={ {marginTop: '20px', display: 'block', margin: '20px auto'} }>Guardar local</button>
            </form>

            <div className="qr-code-generator-form">
                <InputText placeholder="Numero de mesa" type="number" onChange={ (evt) => setTableNumber(evt.target.value) }/>
                <p>QR Code URL: <strong><a target={'_blank'} rel="noreferrer" href={ getQRCodeURL() }>{getQRCodeURL()} </a></strong></p>
                { local_id ? <QRCodeCanvas value={ getQRCodeURL()} /> : null}
                

            </div>

            <Modal title={ modalState.title } visible={ modalState.visible }  handleModalClose={ () => { handleModalClose(); } }>
                { modalState.content }
            </Modal>
        </div>
    );
}